"use client";

import React from "react";
import { ArrowUpRight } from "lucide-react";
import { motion, useReducedMotion } from "framer-motion";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function FindBull() {
  const shouldReduceMotion = useReducedMotion();
  return <section id="find-the-right-new-mechanical-bull" data-nav="light" className="relative bg-background py-16 sm:py-20 lg:py-24 border-t border-b border-border">
      {/* Anchor alias to support alternate navigation format */}
      <span id="findtherightnewmechanicalbull" className="sr-only" aria-hidden="true" />

      <div className="mx-auto max-w-5xl px-4 sm:px-6 lg:px-8">
        <motion.div initial={shouldReduceMotion ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.3
      }} transition={{
        duration: 0.3,
        ease: [0.16, 1, 0.3, 1]
      }} className="relative border border-border bg-card p-6 sm:p-10 lg:p-12 shadow-xs">
          {/* Industrial technical corner registration marks */}
          <div className="pointer-events-none absolute -top-[5px] -left-[5px] size-2 border-t-2 border-l-2 border-foreground/40" />
          <div className="pointer-events-none absolute -top-[5px] -right-[5px] size-2 border-t-2 border-r-2 border-foreground/40" />
          <div className="pointer-events-none absolute -bottom-[5px] -left-[5px] size-2 border-b-2 border-l-2 border-foreground/40" />
          <div className="pointer-events-none absolute -bottom-[5px] -right-[5px] size-2 border-b-2 border-r-2 border-foreground/40" />

          {/* Inner hairline border inset */}
          <div className="border border-border/60 bg-muted/20 p-6 sm:p-8 lg:p-10">
            {/* Main Content Area */}
            <div className="space-y-4">
              <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight uppercase text-foreground">
                Find the Right New Mechanical Bull
              </h2>

              <p className="font-sans text-base sm:text-lg leading-relaxed text-foreground max-w-3xl">
                A new mechanical bull is a significant equipment purchase, so compare more than the price. Review the controller, motion system, safety arena, power requirements, dimensions, included components, parts availability and delivery information before choosing a model.
              </p>

              <p className="font-sans text-sm sm:text-base leading-relaxed text-muted-foreground max-w-3xl">
                Browse our current new mechanical bulls for sale, or contact us about the particular machine you are considering.
              </p>
            </div>

            {/* Action Group */}
            <div className="mt-8 flex flex-col sm:flex-row items-stretch sm:items-center gap-4 pt-2">
              <Button asChild className="h-12 px-7 bg-primary text-primary-foreground font-mono text-xs uppercase tracking-widest font-semibold rounded-none border border-primary hover:bg-primary/90 transition-colors">
                <Link to="#product-catalog" className="flex items-center justify-center gap-2">
                  <span>SHOP NEW MECHANICAL BULLS</span>
                  <ArrowUpRight className="size-4" />
                </Link>
              </Button>

              <Button asChild variant="outline" className="h-12 px-7 bg-transparent text-foreground border-border font-mono text-xs uppercase tracking-widest font-semibold rounded-none hover:bg-accent hover:text-accent-foreground hover:border-foreground/30 transition-colors">
                <Link to="/RequestQuotePage" className="flex items-center justify-center gap-2">
                  <span>ENQUIRE ABOUT A BULL</span>
                </Link>
              </Button>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}